// NOTE temporary icon until one is defined by the customer
export const defaultIcon = require(`@/assets/icons/icon-learn.svg`);

export function modulesAdapter(modules) {
  return modules.map((moduleSkill) => ({
    alt: `${moduleSkill.module_name}-icon`,
    icon: moduleSkill.icon || defaultIcon,
    id: moduleSkill.id,
    module: moduleSkill.module,
    module_name: moduleSkill.module_name,
    module_order: moduleSkill.module_order,
    name: moduleSkill.name || '',
    order: moduleSkill.order || 0,
    pages: moduleSkill.pages || [],
    topics: moduleSkill.topics || 0,
    topics_viewed: moduleSkill.topics_viewed || 0,
    unlocked: moduleSkill.unlocked,
    user: moduleSkill.user,
  }));
}
